let Period = {
  MOURNING: {name: 'Manhã'},
  AFTERNOON: {name: 'Tarde'},
  EVENING: {name: 'Noite'},
};

export default Period;
export const period = Object.keys(Period).map(key => Period[key]);



// WEBPACK FOOTER //
// ./src/enums/Period.js